/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable dot-notation */
let instancePromise: Promise<any> | null = null;

// 動態載入 Sentry SDK，避免整包進每頁共用 chunk
const loadSentry = (): Promise<any> => {
	if (!instancePromise) {
		instancePromise = import('@sentry/node').catch(() => null);
	}
	return instancePromise;
};

export const sentrySetContext = (key: string, context: Record<string, unknown>): void => {
	loadSentry().then(Sentry => { if (Sentry) Sentry.setContext(key, context); });
};

export const sentryConfigureScope = (callback: (scope: any) => void): void => {
	loadSentry().then(Sentry => { if (Sentry) Sentry.configureScope(callback); });
};

export const sentryCaptureException = (error: unknown): void => {
	loadSentry().then(Sentry => { if (Sentry) Sentry.captureException(error); });
};
